<h4 class="mb-4">{{ titleForm }}</h4>
<mat-card class="form-app-card">
    <mat-card-content>
        <form [formGroup]="form" (submit)="submit()">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header class="section-panel-header">
                    <mat-panel-title>
                        <app-section-header
                            [title]="contactInformationDescription.title"
                            [description]="contactInformationDescription.description"
                        ></app-section-header>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Primary contact</mat-label>
                        <input id="primary-contact" matInput formControlName="primaryContactName" required />
                        @if (primaryContactName.invalid && primaryContactName.hasError('required')) {
                            <mat-error>This field is required</mat-error>
                        }
                    </mat-form-field>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field appearance="outline" class="width-100">
                                <mat-label>Contact Email</mat-label>
                                <input
                                    id="contact-email"
                                    matInput
                                    type="email"
                                    formControlName="contactEmail"
                                    required
                                />
                                @if (contactEmail.invalid && contactEmail.hasError('email')) {
                                    <mat-error>Invalid email</mat-error>
                                }
                                @if (contactEmail.invalid && contactEmail.hasError('required')) {
                                    <mat-error>This field is required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field appearance="outline" class="width-100">
                                <mat-label>Contact Phone</mat-label>
                                <input matInput formControlName="phone" required id="contact-phone" />
                                @if (phone.invalid && phone.hasError('phone')) {
                                    <mat-error>Invalid phone</mat-error>
                                }
                                @if (phone.invalid && phone.hasError('required')) {
                                    <mat-error>This field is required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>

            <app-organization-details-section #orgDetails></app-organization-details-section>
            <app-payment-settings #paymentSettings></app-payment-settings>
            <app-domain-hosting-section #domainHostingSection></app-domain-hosting-section>
            <!-- Upload and Preview Light Logo -->
            <app-branding-section #brandingSection></app-branding-section>
            <!-- Privacy & Terms -->
            <app-legal-and-terms-section #legalSection></app-legal-and-terms-section>
            <!-- Features Section -->
            <app-feature-section #featureSection [isEdition]="isEdition"></app-feature-section>
            <div class="mt-2">
                <ng-template
                    [ngTemplateOutlet]="buttonSubmitTemplateRef"
                    [ngTemplateOutletContext]="{ $implicit: form }"
                >
                </ng-template>
            </div>
        </form>
    </mat-card-content>
</mat-card>
